import React from 'react';

const Compose: React.FC = () => {
  return (
    <div>
      <h1>Compose Mail Page</h1>
    </div>
  );
};

export default Compose;
